module.exports = __webpack_public_path__ + "img/IMG_1458_L_Black.1d5dbc02.jpg";